import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 45 45",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M17.7 21l-2.1-1.4c1.5-2.3 4-3.7 6.7-3.7s5.2 1.4 6.7 3.7L26.9 21c-1-1.6-2.7-2.5-4.6-2.5-1.8 0-3.6 1-4.6 2.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-secondary",
			d: "M13.2 16.1l-1.9-1.6c2.8-3.2 6.8-5 11-5s8.3 1.8 11 5l-1.9 1.6c-2.3-2.7-5.6-4.2-9.1-4.2s-6.8 1.5-9.1 4.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M22.3 25.2c-1.5 0-3.1-.6-4.2-1.7l-8.9-8.8H11V2.6l1.5.4c3.2.8 6.6 1.2 10 1.2 3.2 0 6.5-.4 9.6-1.2l1.5-.4v13.9l-7.1 7c-1.1 1.2-2.6 1.7-4.2 1.7zm-8.8-9.7l6.3 6.2c1.4 1.3 3.6 1.3 5 0l6.4-6.3V5.8c-2.8.6-5.7.9-8.6.9-3 0-6.1-.3-9-.9v9.7z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-fill-primary",
			d: "M22.5 42C11.1 42 1.5 30.9.2 16.1L0 14.8h12.2v2.5H2.8c1.6 12.8 9.9 22.3 19.7 22.3 9.8 0 18.1-9.5 19.7-22.3h-9.8v-2.5H45l-.1 1.4C43.6 30.9 33.9 42 22.5 42z"
		})
	]
});
export default SvgIcon;
